import { AnyAction } from 'redux';
import { CancelOrderDto, CreateOrderDto, GetOrderDto, GetOrderListDto, UpdateOrderDto } from 'src/dtos';
import { Order, OrderDetails } from 'src/models';

import { FromTradingBlockServerEvent } from '../events/FromTradingBlockServerEvent';

import { createAction, State, Type } from './utils';

export const doGetOrderList = (payload: GetOrderListDto & { fetchAll?: boolean }): AnyAction =>
  createAction(State.actionRequested(Type.GET_ORDERS), payload);

export const doSucceededGetOrderList = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_ORDERS), payload);

export const doGetOrder = (payload: GetOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_ORDERS_ID), payload);

export const doSucceededGetOrder = (payload?: OrderDetails): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_ORDERS_ID), payload);

export const doFailedGetOrder = (payload: { id: string; error: any }): AnyAction =>
  createAction(State.actionFailed(Type.GET_ORDERS_ID), payload);

export const doClearGetOrder = (payload: { id: string }): AnyAction =>
  createAction(State.actionCleared(Type.GET_ORDERS_ID), payload);

export const doCreateOrder = (payload: CreateOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.CREATE_ORDER), payload);

export const doSucceededCreateOrder = (payload?: Order): AnyAction =>
  createAction(State.actionSucceeded(Type.CREATE_ORDER), payload);

export const doFailedCreateOrder = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.CREATE_ORDER), payload);

export const doClearCreateOrder = (): AnyAction => createAction(State.actionCleared(Type.CREATE_ORDER));

export const doUpdateOrder = (payload: UpdateOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.UPDATE_ORDER), payload);

export const doSucceededUpdateOrder = (payload?: Order): AnyAction =>
  createAction(State.actionSucceeded(Type.UPDATE_ORDER), payload);

export const doClearUpdateOrder = (): AnyAction => createAction(State.actionCleared(Type.UPDATE_ORDER));

export const doCancelOrder = (payload: CancelOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.CANCEL_ORDER), payload);

export const doSucceededCancelOrder = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.CANCEL_ORDER), payload);

export const doClearCancelOrder = (): AnyAction => createAction(State.actionCleared(Type.CANCEL_ORDER));

export const updateOrderFromEvent = (payload: FromTradingBlockServerEvent.OrderUpdateEventPayload): AnyAction =>
  createAction(Type.UPDATE_ORDER_FROM_EVENT, payload);

export const doGetCumulativeOrderList = (payload: GetOrderListDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_CUMULATIVE_ORDER_LIST), payload);

export const doSucceededGetCumulativeOrderList = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_CUMULATIVE_ORDER_LIST), payload);

export const doFailedGetCumulativeOrderList = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.GET_CUMULATIVE_ORDER_LIST), payload);

export const doClearGetCumulativeOrderList = (): AnyAction =>
  createAction(State.actionCleared(Type.GET_CUMULATIVE_ORDER_LIST));
